<template>
    <div class="input-group coupon-code-input">
        <input type="text" v-model="form.code" class="form-control form-control-sm" :placeholder="placeholder">
        <div class="input-group-append">
            <button @click="submit" class="btn btn-sm btn-success" :disabled="isDisabled" type="button">Apply</button>
        </div>
    </div>
</template>
<script>
    export default {

        props: {
            user: {
                type: Object,
                required: true,
            },
            placeholder:{
                type: String,
                required: false,
                default: "Discount Code",
            }
        },

        data() {
            return {
                form: new Form({
                    code: '',
                })
            }
        },

        methods:{
            submit() {
                this.form.post(`/api/discounts/${this.user.id}/code`)
                    .then(response => {
                        App.bus.$emit('discount-applied', response.discount)
                    })
                    .catch(errors => {
                        Alert.error(errors.first())
                    })
            }
        },

        computed:{
            isDisabled(){
                return this.form.code.trim().length <= 3 || this.form.isSubmitted
            }
        }
    }
</script>
